<!-- Mobile-Optimized Barcode Add Component -->
<div class="mobile-barcode-add-container">
  
  <!-- Header Section -->
  <div class="barcode-add-header">
    <div class="header-content">
      <mat-icon class="header-icon">qr_code_scanner</mat-icon>
      <div class="header-text">
        <h4 *ngIf="searchedfor" class="barcode-title">Adding Barcode</h4>
        <p class="barcode-code">{{ searchedfor }}</p>
      </div>
    </div>
  </div>

  <!-- Step 1: Item Search -->
  <div class="step-section" *ngIf="!selecteditem">
    <div class="step-header">
      <div class="step-number">1</div>
      <h5 class="step-title">Find the Item</h5>
    </div>
    
    <!-- Search Input -->
    <div class="search-container">
      <mat-form-field appearance="outline" class="mobile-search-field">
        <mat-label>Search for item...</mat-label>
        <input 
          type="text" 
          placeholder="Type item name, SKU, or description" 
          aria-label="Search for item" 
          matInput 
          [formControl]="itemSearchForm"
          class="mobile-search-input">
        <button 
          *ngIf="itemSearchForm.value != ''" 
          matSuffix 
          mat-icon-button 
          aria-label="Clear search" 
          (click)="itemSearchForm.setValue('')"
          class="clear-search-btn">
          <mat-icon>close</mat-icon>
        </button>
        <mat-hint *ngIf="filteredItems.length" class="search-hint">
          Found {{ filteredItems.length }} item{{ filteredItems.length !== 1 ? 's' : '' }}
        </mat-hint>
      </mat-form-field>
    </div>

    <!-- Loading State -->
    <div class="loading-container" *ngIf="searching">
      <div class="loading-spinner">
        <mat-spinner diameter="24"></mat-spinner>
      </div>
      <p class="loading-text">Searching items...</p>
    </div>

    <!-- Search Results -->
    <div class="search-results" *ngIf="!searching && filteredItems.length > 0">
      <div class="results-header">
        <mat-icon>inventory</mat-icon>
        <span>Select an item below:</span>
      </div>
      
      <div class="item-list">
        <div 
          class="item-card" 
          *ngFor="let item of filteredItems; trackBy: trackByItem" 
          (click)="selectItem(item)"
          [class.selected]="selecteditem && selecteditem.stockid === item.stockid">
          
          <div class="item-main-info">
            <div class="item-sku">{{ item.stockid }}</div>
            <div class="item-description">{{ item.description }}</div>
          </div>
          
          <div class="item-details">
            <div class="item-detail" *ngIf="item.supplierno">
              <mat-icon>label</mat-icon>
              <span>{{ item.supplierno }}</span>
            </div>
            <div class="item-detail" *ngIf="item.bin">
              <mat-icon>location_on</mat-icon>
              <span>{{ item.bin }}</span>
            </div>
          </div>
          
          <div class="item-action">
            <mat-icon>arrow_forward_ios</mat-icon>
          </div>
        </div>
      </div>
    </div>

    <!-- No Results -->
    <div class="no-results" *ngIf="!searching && filteredItems.length === 0 && itemSearchForm.value">
      <div class="no-results-content">
        <mat-icon>search_off</mat-icon>
        <h6>No items found</h6>
        <p>Try searching with different keywords</p>
      </div>
    </div>
  </div>

  <!-- Step 2: Confirm and Save -->
  <div class="step-section" *ngIf="selecteditem">
    <div class="step-header">
      <div class="step-number">2</div>
      <h5 class="step-title">Confirm & Save</h5>
    </div>

    <!-- Selected Item Display -->
    <div class="selected-item-card">
      <div class="selected-item-header">
        <mat-icon class="selected-icon">check_circle</mat-icon>
        <div class="selected-item-info">
          <div class="selected-sku">{{ selecteditem.stockid }}</div>
          <div class="selected-description">{{ selecteditem.description }}</div>
        </div>
      </div>
      
      <div class="selected-item-details">
        <div class="detail-row" *ngIf="selecteditem.supplierno">
          <span class="detail-label">Part Number:</span>
          <span class="detail-value">{{ selecteditem.supplierno }}</span>
        </div>
        <div class="detail-row" *ngIf="selecteditem.bin">
          <span class="detail-label">Bin Location:</span>
          <span class="detail-value">{{ selecteditem.bin }}</span>
        </div>
      </div>
    </div>

    <!-- Barcode Input -->
    <div class="barcode-input-section">
      <mat-form-field appearance="outline" class="mobile-barcode-field">
        <mat-label>Barcode to add</mat-label>
        <input 
          type="text" 
          placeholder="Enter or scan barcode" 
          aria-label="Barcode to add" 
          matInput 
          [formControl]="barcodeForm"
          class="mobile-barcode-input">
        <button 
          *ngIf="barcodeForm.value != ''" 
          matSuffix 
          mat-icon-button 
          aria-label="Clear barcode" 
          (click)="barcodeForm.setValue('')"
          class="clear-barcode-btn">
          <mat-icon>close</mat-icon>
        </button>
        <mat-hint class="barcode-hint">
          This barcode will be linked to {{ selecteditem.stockid }}
        </mat-hint>
      </mat-form-field>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <button 
        mat-stroked-button 
        (click)="goBackToSearch()" 
        class="back-btn"
        [disabled]="sending">
        <mat-icon>arrow_back</mat-icon>
        <span>Back to Search</span>
      </button>
      
      <button 
        mat-raised-button 
        color="primary" 
        (click)="saveBarcode($event)" 
        class="save-btn"
        [disabled]="!barcodeForm.value || sending">
        <mat-icon *ngIf="!sending">save</mat-icon>
        <mat-spinner *ngIf="sending" diameter="20"></mat-spinner>
        <span>{{ sending ? 'Saving...' : 'Save Barcode' }}</span>
      </button>
    </div>
  </div>

  <!-- Error Messages -->
  <div class="error-container" *ngIf="errorMessage">
    <div class="error-content">
      <mat-icon>error</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>
  </div>

</div>
